import { render, staticRenderFns } from "./AppExtra.vue?vue&type=template&id=41789e97"
import script from "./AppExtra.vue?vue&type=script&lang=babel"
export * from "./AppExtra.vue?vue&type=script&lang=babel"
import style0 from "./AppExtra.vue?vue&type=style&index=0&id=41789e97&prod&lang=sass"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports